export default {
  "ERRORS:NOT_FOUND:TITLE-TEXT": "Page not found.",
};
